import { BotAvatar, UserAvatar } from './Avatars.jsx'

export default function MessageBubble({ role, text }) {
  const isUser = role === 'user'
  return (
    <div className={`message-row ${isUser ? 'message-row-user' : 'message-row-bot'}`}>
      {!isUser && <BotAvatar size={36} className="message-avatar" />}
      <div className={`bubble ${isUser ? 'bubble-user' : 'bubble-bot'}`}>{text}</div>
      {isUser && <UserAvatar size={36} className="message-avatar" />}
    </div>
  )
}
